import SEO from "@/components/SEO";
import CitiesList from "@/components/CitiesList";
import { RevealBlock } from "@/components/Reveal";
import { cities } from "@/data/cities";

export default function Cities() {
  return (
    <>
      <SEO
        title="Cities & Towns Covered Across Nova Scotia"
        description={`Licensed security services across ${cities.length} Nova Scotia communities — Halifax, Sydney, Dartmouth, Truro, Yarmouth, New Glasgow, Cape Breton, and the entire province.`}
        path="/cities"
        keywords={cities.slice(0, 30).map((c) => `security guards ${c.name} Nova Scotia`)}
      />
      <section className="max-w-[1600px] mx-auto px-6 lg:px-12 pt-16 md:pt-24 pb-8">
        <p className="font-mono text-[11px] uppercase tracking-[0.28em] text-[#C17A43] mb-8">
          — {cities.length} Communities
        </p>
        <RevealBlock>
          <h1 className="font-serif text-[clamp(3rem,9vw,9rem)] leading-[0.88] tracking-tighter text-[#111111]">
            Every corner<br />
            <span className="italic text-[#184C59]">of Nova Scotia.</span>
          </h1>
        </RevealBlock>
        <p className="mt-8 font-sans text-lg text-[#111111]/70 max-w-[64ch]">
          We deploy officers from Yarmouth to Sydney, from the Bay of Fundy to
          the Cabot Trail. Each community below carries its own operational
          profile, its own risks, and its own team.
        </p>
      </section>
      <CitiesList />
    </>
  );
}
